export const EMAIL_ADDRESSES = {
  careers: 'jobs@tornado.com',
  press: 'press@tornado.com',
  squad: 'squad@tornado.com',
  theStreetMembershipSupport: 'members@thestreet.com',
};
